require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = 0